import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const CreditOverview = ({customer}) => {

  const creditData = [
    { balance: "Credit Card Limit",value: customer["Credit Card Limit"]},
    { balance: "Credit Card Statement Balance",value: customer["Credit Card Statement Balance"]},
    { balance: "Savings Account Balance",value: customer["Savings Account Balance"]},
    { balance: "Current Account Balance",value: customer["Current Account Balance"]},
    { balance: "Term Deposit Balance",value: customer["Term Deposit Balance"]},
    { balance: "Credit Card Balance",value: customer["Credit Card Balance"]},
    { balance: "Personal Loan Balance",value: customer["Personal Loan Balance"]},
    { balance: "Insurance Balance",value: customer["Insurance Balance"]},
    { balance: "Investment Balance",value: customer["Investment Balance"]},
    { balance: "Auto Loan Balance",value: customer["Auto Loan Balance"]},
    { balance: "Mortgage Balance",value: customer["Mortgage Balance"]},
  ];

  return (
    <div className="bg-[#1A1A1A] p-6 rounded-xl border border-[#2A2A2A] shadow-xl">
      <h3 className="text-lg font-semibold mb-6 text-[#FFFFFF]">Credit Overview</h3>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={creditData}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#3A3A3A" />
            <XAxis dataKey="balance" tick={{ fill: '#B0B0B0' }} />
            <YAxis tick={{ fill: '#B0B0B0' }} />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: '#2A2A2A', 
                border: '1px solid #3A3A3A',
                borderRadius: '8px',
                color: '#FFFFFF'
              }}
            />
            <Legend wrapperStyle={{ color: '#FFFFFF' }} />
            <Bar dataKey="value" fill="#B4E50D" name="Credit" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default CreditOverview;